import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/abcf99d398728451b5193d517442b8ca.jpg)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full pt-20">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-8 py-4 bg-teal-600 text-white text-base font-semibold rounded-lg hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              {t('hero.cta')}
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-lg hover:bg-white/20 transition-all duration-300 border-2 border-white/40 whitespace-nowrap"
            >
              {t('hero.ctaSecondary')}
            </button>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <button 
            onClick={() => scrollToSection('stats')}
            className="text-white/80 hover:text-white transition-colors cursor-pointer"
          >
            <i className="ri-arrow-down-line text-3xl"></i>
          </button>
        </div>
      </section>

      <section id="stats" className="relative bg-white py-12 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                <i className="ri-award-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-2">{t('stats.experience')}</h3>
              <p className="text-sm text-gray-600 font-medium">{t('stats.experienceLabel')}</p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                <i className="ri-user-heart-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-2">{t('stats.patients')}</h3>
              <p className="text-sm text-gray-600 font-medium">{t('stats.patientsLabel')}</p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                <i className="ri-team-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-3xl font-bold text-gray-900 mb-2">{t('stats.specialists')}</h3>
              <p className="text-sm text-gray-600 font-medium">{t('stats.specialistsLabel')}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;